module.exports = __webpack_public_path__ + "img/logo_3.95ec8ed7.svg";